import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
  Container,
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import SendIcon from '@mui/icons-material/Send';
import AuthLogo from '../../components/common/AuthLogo';
import hosannaTextLogo from '../../assets/hosanna_text_logo.png';

function PhoneLogin({ onSendCode, loading }) {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');

  // Add invisible div for reCAPTCHA
  useEffect(() => {
    // Create invisible container for reCAPTCHA if it doesn't exist
    if (!document.getElementById('recaptcha-container')) {
      const div = document.createElement('div');
      div.id = 'recaptcha-container';
      div.style.display = 'none';
      document.body.appendChild(div);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!phoneNumber) {
      setError('Phone number is required');
      return;
    }

    // Remove all non-digit characters
    const digits = phoneNumber.replace(/\D/g, '');

    // Validate that it's exactly 10 digits
    if (digits.length !== 10) {
      setError('Please enter a valid 10-digit phone number');
      return;
    }

    // Always add +91 prefix for Indian numbers
    const formattedPhone = `+91${digits}`;

    try {
      await onSendCode(formattedPhone);
    } catch (err) {
      setError(err.message || 'Failed to send verification code');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          minHeight: '100vh',
          backgroundColor: 'background.default',
          pt: 4,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', maxWidth: 400 }}>
          <Box
            component="img"
            src={hosannaTextLogo}
            alt="Hosanna"
            sx={{
              maxWidth: { xs: '200px', sm: '250px' },
              width: '100%',
              height: 'auto',
              mb: 3,
            }}
          />
        <Card sx={{ width: '100%' }}>
          <CardContent sx={{ p: 4 }}>
            <AuthLogo maxWidth={200} maxHeight={200} />
            <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ color: 'primary.main' }}>
              Welcome
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
              Enter your phone number to receive a verification code
            </Typography>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <Box component="form" onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Phone Number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="9876543210"
                helperText="Enter your 10-digit mobile number"
                margin="normal"
                disabled={loading}
                inputProps={{ 
                  inputMode: 'numeric',
                  maxLength: 10,
                  pattern: '[0-9]*'
                }}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                sx={{ mt: 3, py: 1.5 }}
                disabled={loading}
                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
              >
                {loading ? 'Sending...' : 'Send Code'}
              </Button>
            </Box>
          </CardContent>
        </Card>
        </Box>
      </Box>
    </Container>
  );
}

export default PhoneLogin;

